import { Component, Injectable, Input, Compiler } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { ConsumeService } from '../../../../../app/services/consume.service';

/**
 * @version $Id$
 */
@Component({
  selector: 'moveConsume',
  templateUrl: './content.confirmation.modal.template.html'
})
@Injectable()
export class MoveLineConfirmationComponent {

  private selectedGroup: DataPackGroup;
  private lines: Map<string, DataPackLine>;
  private groups: Array<DataPackGroup>;
  private destinationGroupId: string;
  private saving: boolean = false;
  private message: string;

  constructor(private activeModal: NgbActiveModal, private consumeService: ConsumeService, private alertService: AlertService) {
  }

  private close() {
    this.activeModal.dismiss();
  }

  private setDestinyGroupId(id: string) {
    this.destinationGroupId = id;
  }

  private save() {
    this.saving = true;
    let payload: any = {};
    payload.action = 'moveLines';
    payload.sourceGroup = {id: this.selectedGroup.id};
    payload.destinationGroup = {id: this.destinationGroupId};
    payload.lines = [];
    for(let entry of Array.from(this.lines.entries())) {
      payload.lines.push(entry[1]);
    }
    this.consumeService.save(payload).subscribe(
      data => {
        this.saving = false;
        this.activeModal.close();
        this.alertService.success(data['result']);
      },
      err => {
        this.saving = false;
        this.activeModal.close();
        this.alertService.error(err.result, err);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/move/content.confirmation.component.ts